import { icons } from 'common'
import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  a {
    color: #fff;
    text-decoration: none;
    text-decoration-color: rgba(255, 255, 255, 0.4);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  a:hover {
    text-decoration: none;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.5);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  .info_icon {
    position: relative;
    background: hsla(0, 0%, 100%, 0.1) url(${icons.info_icon}) center center / auto 10px no-repeat;
    padding: 0;
    margin: 0 5px 0 0;
    border-radius: 6px;
    display: flex;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .info_icon:hover {
    background-color: hsla(0, 0%, 100%, 0.2);
  }
  .content {
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/modal.css */
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
  }
  article {
    max-height: 800px;
    height: fit-content;
    backdrop-filter: blur(10px);
    border-radius: 0 0 10px 10px;
    padding: 0 30px 30px;
    display: flex;
    flex-direction: column;
  }
  .popup:target .popUpContainer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/user-account.css */
  .popUpContainer.user-account article {
    flex-wrap: wrap;
    flex-direction: column;
    position: relative;
    z-index: 1;
    padding: 0 0 30px 0;
  }
  .popUpContainer.user-account .profile_header {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    padding: 20px 30px;
    align-items: center;
  }
  .popUpContainer.user-account .content {
    width: 100%;
    align-items: flex-start;
    /* border-top: 1px solid hsla(0, 0%, 100%, 0.1); */
    padding: 30px 0 0 0;
    overflow: visible;
  }

  .popUpContainer.user-account .profile_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .popUpContainer.user-account .profile_wrapper .avatar_form {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .popUpContainer.user-account .profile_wrapper .avatar_form label {
    cursor: pointer;
  }

  .popUpContainer.user-account .profile_wrapper .avatar_form.other .profile_avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    background: url(${({ avatar }) => avatar}) center center / cover no-repeat;
    width: 50px;
    height: 50px;
    border-radius: 10px;
  }
  .popUpContainer.user-account .profile_wrapper .avatar_form.other .profile_avatar:before {
    display: flex;
    position: absolute;
    content: '';
    left: -1px;
    bottom: -1px;
    align-items: center;
    justify-content: center;
    background: hsla(0, 0%, 0%, 0.6) url(${icons.clone_bid_icon}) center center / auto 12px no-repeat;
    backdrop-filter: blur(20px);
    width: 12px;
    height: 12px;
    padding: 6px;
    border-radius: 0 10px 0 10px;
  }
  .popUpContainer.user-account .clone_bids_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: hsla(0, 0%, 0%, 0.2);
    padding: 10px;
    border-radius: 10px;
  }
  .popUpContainer.user-account .clone_bids_wrapper .title {
    font-size: 0.9rem;
    text-transform: uppercase;
    display: flex;
    font-weight: 600;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    padding: 0 0 0 34px;
    position: relative;
  }
  .popUpContainer.user-account .clone_bids_wrapper .title:before {
    background: hsla(0, 0%, 0%, 0.6) url(${icons.clone_bid_icon}) center center / 12px auto no-repeat;
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    padding: 8px;
    border-radius: 50%;
  }
  .popUpContainer.user-account .clone_bids_wrapper .info_icon {
    margin: 0;
    background-size: auto 8px;
    width: 28px;
    height: 20px;
    padding: 0 6px;
    align-self: center;
  }
  .popUpContainer.user-account .profile_wrapper .profile_name {
    margin: 0 0 0 15px;
    font-weight: 600;
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .bc_switch_wrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 0 0 0 10px;
  }
  .bc_switch_wrapper input.toggle_switch_bc {
    opacity: 0;
    position: absolute;
  }
  .bc_switch_wrapper input.toggle_switch_bc + label {
    position: relative;
    display: inline-block;
    user-select: none;
    -moz-transition: 0.4s ease;
    -o-transition: 0.4s ease;
    -webkit-transition: 0.4s ease;
    transition: 0.4s ease;
    -webkit-tap-highlight-color: transparent;
    height: 24px;
    width: 42px;
    border: 1px solid hsla(0, 0%, 100%, 0.5);
    border-radius: 60px;
    cursor: pointer;
  }
  .bc_switch_wrapper input.toggle_switch_bc:checked + label {
    border: 1px solid var(--toggle-active-body-background);
  }
  .bc_switch_wrapper input.toggle_switch_bc + label:before {
    content: '';
    position: absolute;
    display: block;
    -moz-transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    -o-transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    -webkit-transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    height: 24px;
    width: 43px;
    top: -1px;
    left: 0;
    border-radius: 30px;
  }
  .bc_switch_wrapper input.toggle_switch_bc + label:after {
    content: '';
    position: absolute;
    display: block;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 0px 0 rgba(0, 0, 0, 0.04), 0 4px 9px rgba(0, 0, 0, 0.13),
      0 3px 3px rgba(0, 0, 0, 0.05);
    -moz-transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    -o-transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    -webkit-transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    background: whitesmoke;
    height: 24px;
    width: 24px;
    top: -1px;
    left: -1px;
    border-radius: 60px;
  }
  .bc_switch_wrapper input.toggle_switch_bc:checked + label:before {
    background: var(--toggle-active-body-background);
    -moz-transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    -o-transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    -webkit-transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
  }
  .bc_switch_wrapper input.toggle_switch_bc:checked + label:after {
    left: 20px;
  }

  article {
    /* background: var(--overlay-pad-background); */
    /* backdrop-filter: blur(25px); */
  }
`

const cloneBidsWrapper = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .popUpContainer.user-account .clone_bids_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: hsla(0, 0%, 0%, 0.2);
    padding: 15px;
    border-radius: 10px;
  }

  .popUpContainer.user-account .clone_bids_wrapper .title {
    font-size: 0.8rem;
    text-transform: uppercase;
    display: flex;
    font-weight: 600;
    flex-direction: column;
    align-items: flex-start;
    white-space: nowrap;
    padding: 2px 0 0 34px;
    position: relative;
  }
  .popUpContainer.user-account .clone_bids_wrapper .title:before {
    background: hsla(0, 0%, 0%, 0.6) url(${icons.clone_bid_icon}) center center / 12px auto no-repeat;
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    padding: 8px;
    border-radius: 50%;
  }

  .clone_bids_wrapper .title .custom_fee_rate {
    text-transform: none;
    font-size: 0.7rem;
    padding: 3px 0 0 0;
  }
  .popUpContainer.user-account .clone_bids_wrapper .info_icon {
    margin: 0;
  }
  .popUpContainer.user-account .clone_bids_wrapper .info_icon {
    background-size: auto 8px;
    width: 28px;
    height: 20px;
    padding: 0 6px;
  }
  .popUpContainer.user-account .clone_bids_main_wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  .popUpContainer.user-account .clone_bids_wrapper form {
    padding: 10px 0 0 0;
    width: 100%;
  }
  .popUpContainer.user-account .clone_bids_wrapper form label {
    font-size: 0.75rem;
    opacity: 0.7;
  }
  .popUpContainer.user-account .clone_bids_wrapper fieldset {
    margin: 5px 0 0 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    border: 2px solid var(--toggle-active-body-background);
    border-radius: 10px;
  }

  .popUpContainer.user-account .clone_bids_wrapper fieldset input.clone_bid_max-amount {
    background: hsl(231, 5%, 30%);
    padding: 6px 14px;
    width: 100%;
    border-radius: 7px 0 0 7px;
  }
  .popUpContainer.user-account .clone_bids_wrapper fieldset input.clone_bid_max-amount:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .popUpContainer.user-account .clone_bids_wrapper fieldset button.save {
    padding: 6px 10px 5px 10px;
    font-size: 0.8rem;
    border-radius: 0 7px 7px 0;
    white-space: nowrap;
  }
  .popUpContainer.user-account .clone_bids_wrapper fieldset button.save:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .bc_switch_wrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0 0 0 10px;
  }
  .bc_switch_wrapper input.toggle_switch_bc {
    opacity: 0;
    position: absolute;
  }
  .bc_switch_wrapper input.toggle_switch_bc + label {
    position: relative;
    display: inline-block;
    user-select: none;
    -moz-transition: 0.4s ease;
    -o-transition: 0.4s ease;
    -webkit-transition: 0.4s ease;
    transition: 0.4s ease;
    -webkit-tap-highlight-color: transparent;
    height: 20px;
    width: 40px;
    border: 1px solid hsla(0, 0%, 100%, 0.5);
    border-radius: 60px;
    cursor: pointer;
  }
  .bc_switch_wrapper input.toggle_switch_bc:checked + label {
    border: 1px solid var(--toggle-active-body-background);
  }
  .bc_switch_wrapper input.toggle_switch_bc + label:before {
    content: '';
    position: absolute;
    display: block;
    -moz-transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    -o-transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    -webkit-transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    height: 21px;
    width: 40px;
    top: -1px;
    left: 0;
    border-radius: 30px;
  }
  .bc_switch_wrapper input.toggle_switch_bc + label:after {
    content: '';
    position: absolute;
    display: block;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 0px 0 rgba(0, 0, 0, 0.04), 0 4px 9px rgba(0, 0, 0, 0.13),
      0 3px 3px rgba(0, 0, 0, 0.05);
    -moz-transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    -o-transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    -webkit-transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
    background: whitesmoke;
    height: 20px;
    width: 20px;
    top: -1px;
    left: -1px;
    border-radius: 60px;
  }
  .bc_switch_wrapper input.toggle_switch_bc:checked + label:before {
    background: var(--toggle-active-body-background);
    -moz-transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    -o-transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    -webkit-transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
  }
  .bc_switch_wrapper input.toggle_switch_bc:checked + label:after {
    left: 20px;
  }
`

const developerCSS = css``

export const OtherUserProfileCSS = styled.div`
  ${designerCSS}
  ${cloneBidsWrapper}
  ${developerCSS}
`

export const Close = styled(IconLib).attrs((props) => ({
  collection: 'general',
  name: 'closeOutline',
  dimension: '25px',
}))`
  color: #fff;
  font-size: 1.4rem;
  line-height: 100%;
  position: absolute;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: -8px;
  text-align: center;
  text-decoration: none;
  top: -8px;
  z-index: 1;
  background: rgba(255, 255, 255, 1);

  @media (max-width: 480px) {
    left: -8px;
    top: -8px;
  }
`
